import React from "react";
import { Redirect, useRouteMatch } from "react-router-dom";

import { ImportModalPage } from "./import/constants/import_modal_page";
import { SkillsManagementModalType } from "./import/constants/skills_management_modal_type";
import { SkillsManagementModal } from "./skills_management_modal";

export const SkillsManagementModalController = () => {
  const {
    params: { modalPage, importPage }
  } = useRouteMatch<{ modalPage: SkillsManagementModalType; importPage: ImportModalPage }>();

  if (!Object.values(SkillsManagementModalType).includes(modalPage as SkillsManagementModalType)) {
    return <Redirect to={"/admin/skills_management"} />;
  }
  if (importPage && !Object.values(ImportModalPage).includes(importPage)) {
    return <Redirect to={ImportModalPage.Upload} />;
  }

  return <SkillsManagementModal modalPage={modalPage} importPage={importPage || ImportModalPage.Upload} />;
};
